<template>
	<div class="application-page">
		<b-container>
			<b-row>
				<b-col md="3">
					<Navigation page="exclusions"/>
				</b-col>
				<b-col md="9">
					<h1>Kein Interesse</h1>
					<Listing
						v-if="!loadingJobs"
						:jobs="jobs"
						:loading-jobs="loadingJobs"
						:with-head="false"
						:only-excluded="true"
						:force-listing="true"
					/>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>

<script>
import Navigation from "@/vue/application/profile/Navigation";
import List from "@/vue/application/exclusion/List"
import Listing from "@/vue/application/job/Listing.vue";
import GetList from "@/api/application/job/GetList";

export default {

	components: {
		Listing,
		Navigation,
		List,
	},

	mounted ()
	{
		this.loadJobs();
	},

	data ()
	{
		return {
			loadingJobs: true,
			jobs: undefined,
		}
	},

	methods: {
		async loadJobs ()
		{
			this.loadingJobs = true;

			const response = await new GetList()
				.call();

			this.jobs = response.data;

			this.loadingJobs = false;
			this.initiallyLoadedJobs = true;
		},
	}
}
</script>
